/* unplugin-vue-components disabled */import { render } from "./VersioningVideoDownloadModal.vue?vue&type=template&id=037c5d4a&scoped=true&ts=true"
import script from "./VersioningVideoDownloadModal.vue?vue&type=script&lang=ts"
export * from "./VersioningVideoDownloadModal.vue?vue&type=script&lang=ts"

import "./VersioningVideoDownloadModal.vue?vue&type=style&index=0&id=037c5d4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037c5d4a"]])

export default __exports__